import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseIconButton from './HseIconButton.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseIconButton;

/* template */
var __vue_render__ = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"hse-Button hse-IconButton",class:( _obj = {}, _obj[("hse-Button_variant_" + (_vm.variant === 'default' ? 'primary' : _vm.variant) + " hse-IconButton_variant_" + _vm.variant)] = _vm.variant, _obj['hse-IconButton_spinner'] =  _vm.spinner, _obj['hse-IconButton_spinner_done'] =  _vm.spinner === 'done', _obj[("hse-IconButton_size_" + _vm.size)] = _vm.size, _obj['hse-Button_disabled hse-IconButton_disabled'] =  _vm.disabled, _obj['hse-Button_inactive hse-IconButton_inactive'] =  _vm.inactive, _obj['hse-Button_focused hse-IconButton_focused'] =  _vm.focused, _obj['hse-IconButton_selected'] =  _vm.selected, _obj['hse-Button_custom-color'] =  !!_vm.color, _obj ),style:({color: _vm.color}),attrs:{"disabled":_vm.disabled},on:{"blur":function($event){_vm.focused = false;},"click":_vm.onClick,"focus":function($event){_vm.enabled && (_vm.focused = $event.target.classList.contains('focus-visible'));},"keydown":_vm.onKeyDown,"mousedown":_vm.onMouseDown}},[_c('div',{ref:"bubbleRoot",staticClass:"hse-Button__bubbleRoot"}),_vm._v(" "),_c('div',{staticClass:"hse-Button__content hse-IconButton__content",class:_vm.classes.content},[_vm._t("default",[[(_vm.spinner)?_c('HseSpinner',_vm._b({staticClass:"hse-IconButton__spinner",class:( _obj$1 = {
            'hse-IconButton__spinner_done': _vm.spinner === 'done'
          }, _obj$1[_vm.classes.spinner] = _vm.classes.spinner, _obj$1 )},'HseSpinner',_vm.spinnerProps,false)):(_vm.icon)?_c('HseIcon',{class:_vm.classes.icon,style:({
            color: !_vm.disabled && !_vm.inactive && !_vm.selected ? _vm.iconColor : false
          }),attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e()]],null,{ iconSize: _vm.iconSize })],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
